import IconPicker from './IconPicker'

export default {
  IconPicker
}



// WEBPACK FOOTER //
// ./src/components/index.js